module.exports = __webpack_public_path__ + "img/BG121830616.b8169e62.png";